import api from './api';
import { AreaSnapshot } from '../models';
import { getBackVersion } from '../config';

const getAreaByCityId = (cityId: number): Promise<AreaSnapshot[]> => {
    return api
        .request<AreaSnapshot[]>({
            method: 'GET',
            url: `${getBackVersion()}/cities/${cityId}/areas`,
        })
        .then(areas => {
            return areas.length > 0
                ? areas
                : [
                      {
                          areaType: 'city',
                          cityId: cityId,
                          areaId: cityId,
                          listingCount: 0,
                          percentRank: 0,
                          areaName: 'Todos os bairros',
                      },
                  ];
        });
};

export default { getAreaByCityId };
